@if (
  !isEmbedWLSMode &&
  !isWhiteLabelCoverPageVisible &&
  !isCoverPageShellRoute &&
  !isSocialCallbackRoute
) {
  <app-header></app-header>
} @else if (isEmbedWLSMode) {
  <div
    class="wls-preview-header"
    [class.wls-preview-header--text-logo]="previewIsTextLogo"
  >
    <div class="wls-preview-header__brand">
      @if (previewLogoUrl) {
        <img [src]="previewLogoUrl" alt="Logo" class="wls-preview-logo" />
      }
      @if (!previewLogoUrl && previewTextLogo) {
        <span
          class="wls-preview-header__text-logo"
          [style.font-family]="previewTextLogoFont"
        >
          {{ previewTextLogo }}
        </span>
      }
    </div>
    <div class="wls-preview-header__actions">
      <a class="wls-preview-header__cta" appSpaLink [href]="loginPath">
        {{ wlsPreviewHeaderLabels.GET_STARTED }}
      </a>
      <div class="wls-preview-header__language-switcher">
        <app-language-switcher [isEditMode]="true"></app-language-switcher>
      </div>
    </div>
  </div>
}
<div
  [ngClass]="{
    'main-wrapper container with-sidebar':
      showSidebar && !isWhiteLabelCoverPageVisible,
    'white-label-cover-page-shell': isWhiteLabelCoverPageVisible,
    'white-label-cover-page-shell--with-mobile-nav':
      showCoverPageMobileNav ||
      (showPwaSidebarImmediate &&
        (isWhiteLabelCoverPageVisible || isCoverPageShellRoute)),
    'wls-quick-preview': isEmbedWLSMode
  }"
>
  @if (showAppSidebar) {
    <app-sidebar></app-sidebar>
  }
  <div
    class="router-outlet-wrapper"
    [ngClass]="{ 'with-sidebar': showSidebar && !isWhiteLabelCoverPageVisible }"
  >
    <router-outlet></router-outlet>
  </div>
</div>
@if (
  !isEmbedWLSMode && !isWhiteLabelCoverPageVisible && !isSocialCallbackRoute
) {
  <app-footer></app-footer>
}
<app-minimized-player></app-minimized-player>
@if (showDevToolbar) {
  <app-dev-toolbar></app-dev-toolbar>
}
